import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { A, Card, Div, Layout, NavigationHeader, H3, P } from '@driftt/tide-core'
import CSVImportIcon from 'images/csv-import-icon.svg'
import ImportSourceSuggestionIcon from 'images/import-suggestion-icon.svg'
import ImportSourceSourceSuggestionModal from 'components/Imports/ImportSourceSuggestionModal'

import './style.css'

const mapStateToProps = state => ({
  orgId: state.org.id
})

const IMPORT_TYPES = {
  CSV: 'CSV'
}

const IMPORT_CARDS = [
  {
    type: IMPORT_TYPES.CSV,
    title: 'Import a CSV',
    description: 'Add accounts to Drift from an existing CSV file',
    url: '/imports/new/csv',
    imgSrc: CSVImportIcon
  },
]

class ChooseImportType extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isImportSourceSuggestionModalOpen: false
    }
  }

  navigateToCardLink = (card) => {
    if (!card) {
      return
    }

    const { history } = this.props

    history.push(card.url)
  }

  openImportSourceSuggestionModal = () => {
    this.setState({
      isImportSourceSuggestionModalOpen: true
    })
  }

  closeImportSourceSuggestionModal = () => {
    this.setState({
      isImportSourceSuggestionModalOpen: false
    })
  }

  renderSuggestImportSourceCard = () => {
    return (
      <Div className="choose-import--card-wrapper">
        <Card
          align="left"
          header={"Suggest import source"}
          description={"Don't see an import source that you want? Let our team know!"}
          imgSrc={ImportSourceSuggestionIcon}
          className="choose-import--card choose-import--card--suggestion"
          onClick={this.openImportSourceSuggestionModal}
        />
      </Div>
    )
  }

  renderImportCard = (card) => {
    // Only allow CTA to be clicked if the card is disabled
    const ctaHref = card.disabled ? card.ctaUrl : null
    const cta = (
      <P className="choose-import--card--link">
        <A href={ctaHref} target="_blank">{card.ctaText}</A>
      </P>
    )

    const hasCTA = card.ctaText

    const description = (
      <Fragment>
        {card.description}
        {hasCTA && cta}
      </Fragment>
    )

    return (
      <Div className="choose-import--card-wrapper" key={card.type}>
        <Card
          align="left"
          onClick={() => this.navigateToCardLink(card)}
          header={card.title}
          description={description}
          imgSrc={card.imgSrc}
          className="choose-import--card"
          disabled={card.disabled}
          upgrade={!!card.upgradeText}
          upgradeText={card.upgradeText}
        />
      </Div>
    )
  }

  render() {
    return (
      <Fragment>
        <NavigationHeader title="Import accounts" />
        <Layout>
          <Div className="choose-import--wrapper">
            <H3 className="choose-import--title">Select an import source</H3>
            <Div className="choose-import--all-cards-wrapper">
              {IMPORT_CARDS.map(this.renderImportCard)}
              {this.renderSuggestImportSourceCard()}
            </Div>
            <ImportSourceSourceSuggestionModal
              isOpen={this.state.isImportSourceSuggestionModalOpen}
              onClose={this.closeImportSourceSuggestionModal}
            />
          </Div>
        </Layout>
      </Fragment>
    )
  }
}

export default connect(mapStateToProps)(ChooseImportType)
